/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.web_message.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.web_message = {};
proto.witbooking.backoffice.web_message.v1 = require('./webmessage_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest,
 *   !proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse>}
 */
const methodDescriptor_WebMessageAPI_GetAllWebMessages = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetAllWebMessages',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest,
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest,
 *   !proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse>}
 */
const methodInfo_WebMessageAPI_GetAllWebMessages = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIClient.prototype.getAllWebMessages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetAllWebMessages',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_GetAllWebMessages,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.web_message.v1.GetAllWebMessagesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIPromiseClient.prototype.getAllWebMessages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetAllWebMessages',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_GetAllWebMessages);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse>}
 */
const methodDescriptor_WebMessageAPI_GetWebMessage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetWebMessage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest,
  proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse>}
 */
const methodInfo_WebMessageAPI_GetWebMessage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIClient.prototype.getWebMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_GetWebMessage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.GetWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.web_message.v1.GetWebMessageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIPromiseClient.prototype.getWebMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_GetWebMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse>}
 */
const methodDescriptor_WebMessageAPI_CreateWebMessage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.web_message.v1.WebMessageAPI/CreateWebMessage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest,
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse>}
 */
const methodInfo_WebMessageAPI_CreateWebMessage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIClient.prototype.createWebMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/CreateWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_CreateWebMessage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.CreateWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.web_message.v1.CreateWebMessageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIPromiseClient.prototype.createWebMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/CreateWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_CreateWebMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse>}
 */
const methodDescriptor_WebMessageAPI_UpdateWebMessage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.web_message.v1.WebMessageAPI/UpdateWebMessage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest,
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse>}
 */
const methodInfo_WebMessageAPI_UpdateWebMessage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIClient.prototype.updateWebMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/UpdateWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_UpdateWebMessage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.web_message.v1.UpdateWebMessageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIPromiseClient.prototype.updateWebMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/UpdateWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_UpdateWebMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse>}
 */
const methodDescriptor_WebMessageAPI_DeleteWebMessage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.web_message.v1.WebMessageAPI/DeleteWebMessage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest,
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest,
 *   !proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse>}
 */
const methodInfo_WebMessageAPI_DeleteWebMessage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIClient.prototype.deleteWebMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/DeleteWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_DeleteWebMessage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.web_message.v1.DeleteWebMessageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIPromiseClient.prototype.deleteWebMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/DeleteWebMessage',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_DeleteWebMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesRequest,
 *   !proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse>}
 */
const methodDescriptor_WebMessageAPI_GetConsolidatedWebMessages = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetConsolidatedWebMessages',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesRequest,
  proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesRequest,
 *   !proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse>}
 */
const methodInfo_WebMessageAPI_GetConsolidatedWebMessages = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIClient.prototype.getConsolidatedWebMessages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetConsolidatedWebMessages',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_GetConsolidatedWebMessages,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.web_message.v1.GetConsolidatedWebMessagesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.web_message.v1.WebMessageAPIPromiseClient.prototype.getConsolidatedWebMessages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.web_message.v1.WebMessageAPI/GetConsolidatedWebMessages',
      request,
      metadata || {},
      methodDescriptor_WebMessageAPI_GetConsolidatedWebMessages);
};


module.exports = proto.witbooking.backoffice.web_message.v1;

